/* eslint-disable react-hooks/exhaustive-deps */
import _ from 'lodash';
import { useEffect, useRef, useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import buyPNG from '../assets/img/appraisal/buy.png';
import sellPNG from '../assets/img/appraisal/sell.png';
import settingsPNG from '../assets/img/appraisal/settings.png';
import * as types from '../store/actions/types';
import { RootState } from '../store/reducers';
import { getBadgeTypeImage, history, isUserLoggedIn, userInterested } from '../utils/handler';

import { ContributedDomains, Reviews, StatisticsDetails, WhyChooseSaw } from 'views/components/CommonPages';

// let localAppraisalDetails: any;
export const AppraisalResult: React.FC<any> = ({ handleSubmit, buyDomain, sendAppraisalToMail }): JSX.Element => {
  // const [sendEmail, setSendEmail] = useState<boolean>(false);
  const [readMore, setReadMore] = useState<boolean>(isUserLoggedIn() ? true : false);
  const { previousAction = '', showLoginWindow = false, showVerificationCodeWindow = false } = useSelector((state: RootState) => state.mainReducer);
  // const { myProfile } = useSelector((state: RootState) => state.userReducer);
  const { appraisalSearchHistory = [], appraisalDetails, appraisalError } = useSelector((state: RootState) => state.appraisalReducer);

  const dispatch = useDispatch();

  useEffect(() => {
    if (appraisalError) setAppraisalMessage(appraisalError);
  }, [appraisalError]);

  const setAppraisalMessage = (message: string) => {
    let elem = document.getElementById('appraisal-error');
    if (elem && message) elem.innerHTML = message;
  };

  let componentRef: any = useRef('');
  useEffect(() => {
    // if (localAppraisalDetails) {
    // setAppraisalDetails(localAppraisalDetails);
    // }
    if (isUserLoggedIn() && !showLoginWindow && !showVerificationCodeWindow) {
      if (previousAction === 'readMoreAction') {
        readMoreAction();
      }
      dispatch({ type: types.PREVIOUS_ACTION, payload: '' });
    }
  }, [previousAction, showLoginWindow, showVerificationCodeWindow]);

  // useEffect(() => {
  //   if (myProfile && !_.isEmpty(myProfile) && sendEmail) {
  //     setSendEmail(false);
  //     sendAppraisalToMail();
  //   }
  // }, [myProfile]);

  const getDescriptionLimit = (description: string[]) => {
    if (!readMore && description && description.length > 0) {
      description = description.slice(0, 5);
    }
    return description || [];
  };
  const readMoreAction = () => {
    if (isUserLoggedIn()) {
      setReadMore(!readMore);
    } else {
      dispatch({ type: types.PREVIOUS_ACTION, payload: 'readMoreAction' });
      dispatch({ type: types.SHOW_LOGIN_WINDOW, payload: true });
    }
  };
  const downloadingAppraisal = () => {
    let currentAppraisal = _.find(appraisalSearchHistory, { domain: appraisalDetails.domain });
    return currentAppraisal?.downloadingCertificate ? true : false;
  };
  const getAvailableExtensions = () => {
    return appraisalDetails.availableExtensions.filter((tld: string) => tld.toLocaleLowerCase() !== appraisalDetails.tld.toLocaleLowerCase() && tld).join(', .');
  };
  return (
    <div className="text-center">
      {_.isEmpty(appraisalDetails) ? (
        <div className="card-body position-relative  fs-20">
          {appraisalError ? (
            <div className={'appraisal-error-message container'}>
              <span id="appraisal-error"></span>
              {/* <span className="text-primary hover-u ml-2" onClick={() => handleSubmit()}>
                Retry
              </span>
              <span className="text-dark ml-1 mr-1">or</span> */}
              {/* <span className="text-primary hover-u ml-1" onClick={() => scrollDoc(docIds.contactUs)}>
                Contact us?
              </span> */}
            </div>
          ) : null}
        </div>
      ) : (
        <>
          <div className="container card appraisal-result-body card-shadow" ref={componentRef}>
            <div className="d-flex justify-content-between ">
              <div className="domain-guid dull-color uppercase">Here’s Your Domain Value!</div>
              {isUserLoggedIn() && (
                <span onClick={() => dispatch({ type: types.APPRAISAL_DETAIL, payload: {} })} className="link-style">
                  Show History
                </span>
              )}
              {/* share option */}
              {/* {CheckAccess('ShareDownloadAppraisal') && (
                <div className="domain-guid-icon theme-color">
                  <ReactToPrint documentTitle={'saw-appraisal-' + appraisalDetails.domain} content={() => componentRef} trigger={() => <i className="fa-solid c-pointer fa-download"></i>} />
                </div>
              )} */}
            </div>
            <hr />
            <div className={'card-body justify-content-between domain-detail-card ' + (appraisalSearchHistory.length <= 3 ? 'd-md-flex ' : '')}>
              <div className="left">
                <div className="domain-name theme-color">{appraisalDetails.domain}</div>
                {/* {appraisalDetails.appraised_value ? */}
                <div className="">
                  <div className="dull-color fs-12">Estimated Value (USD)</div>
                  <div>
                    <span className="domain-value">{appraisalDetails.saw_appraised_value_formatted ? appraisalDetails.saw_appraised_value_formatted : `$ ${appraisalDetails.appraised_value}`}</span>
                  </div>
                </div>
                {appraisalDetails && appraisalDetails.appraisalTypes ? (
                  <div className="domain-info">
                    <img src={getBadgeTypeImage({ type: appraisalDetails.appraisalTypes.type, info: 'Platinum Buzz' })} alt="type" className="domain-badge-type" data-toggle="tooltip" />
                    <span className="ml-1">{appraisalDetails.appraisalTypes.info}</span>
                  </div>
                ) : null}
              </div>
              <div className="right">
                {/* download certificate option */}
                <div className="appraisal-button">
                  <button
                    className="fs-11 btn-primary primary-dark btn btn-normal bb-btn ml-auto"
                    onClick={() => sendAppraisalToMail(appraisalDetails.domain)}
                    //  onClick={() => setShowMailModal(true)}
                  >
                    {downloadingAppraisal() ? <i className="fa-solid fa-spinner fa-spin-pulse"></i> : <i className="fa-solid fa-file-pdf fs-16"></i>}
                    <span className="ml-2">Domain Appraisal Certificate</span>
                  </button>
                </div>
                {/* {showBuyButton() ? ( */}
                <div className="appraisal-button">
                  <span className="mt-2  mr-2">Dang. It’s taken. Still want it?</span>
                  <button className="fs-11 btn btn-grad-outline ml-auto bb-btn" id="buy-domain" onClick={() => window.location.href = `https://saw.com/buy-domain`}>
                    Here’s what to do next
                  </button>
                </div>
                {/* ) : null} */}
                {/* {showSellButton() ? ( */}
                <div className="appraisal-button">
                  <span className="mt-2 mr-2">Trying to sell this domain?</span>
                  <button
                    className="fs-11 btn btn-grad-outline d-flex align-items-center  bb-btn ml-auto"
                    onClick={() => {
                      // history.push(`/sell`);
                      window.location.href = `https://saw.com/outbound-brokerage`
                      // localStorage.setItem('_sell_value', String(appraisalDetails.appraised_value));
                      // localStorage.setItem('_sell_worth', String(appraisalDetails.saw_appraised_value));
                      // history.push(`/sell-domain?domain=${appraisalDetails.domain}`);
                      // dispatch({ type: types.SET_CONTACT_US_DOMAIN, payload: appraisalDetails.domain });
                      // scrollDoc(docIds.appraisalContactUs);
                      // buyDomain(userInterested.sell, appraisalDetails.domain);
                    }}
                  >
                    Here’s what to do next
                  </button>
                </div>
                {/* ) : null} */}
              </div>
            </div>
            <hr />
            <div className=" text-left justify-content-start ">
              <div className="dull-color">This is why it’s so valuable:</div>
              <div>
                {appraisalDetails.manualReviewRequire ? (
                  <span className="  fs-16  ">
                    This request is a tricky one! Since this is a beta release, we suggest asking one of our professionals to look deeper into this. You may request a written appraisal for $299.
                    <span onClick={() => history.push('/contact-us')} className=" ms-1 text-primary hover-u click-response">
                      click here
                    </span>
                  </span>
                ) : (
                  <div className="">
                    <ul className="description-list theme-bullets">
                      {getDescriptionLimit(appraisalDetails.description)?.map((description: string, index: number) => (
                        <li key={index}> {description}</li>
                      ))}
                    </ul>
                    {appraisalDetails?.description?.length > 5 && (
                      <div>
                        <span onClick={readMoreAction} className="text-primary c-pointer click-response">
                          {readMore && isUserLoggedIn() ? 'Read less...' : 'Read more...'}
                        </span>
                      </div>
                    )}
                  </div>
                )}

                <hr />
                <div className="willing-compromise">
                  {/* {alternateDomains.length !== 0 && <div className="dull-color">Willing to compromise?</div>} */}
                  {/* <div className="compromise-list">
                    {loaderAlternateDomains ? (
                      <div className="waiting text-center">
                        <ScaleLoader color={'#ff7728;'} loading={true} height={40} width={5} radius={3} margin={3} />
                      </div>
                    ) : (
                      _.isArray(alternateDomains) && (
                        <table className="table table-borderless table-compromise">
                          <tbody>
                            {alternateDomains.map((appraisal: FilteredAppraisal, index: number) => (
                              <tr key={index} className="no-border">
                                <td className="extension">{appraisal.tld}</td>
                                <td className={appraisal.saw_appraised_value > 700 ? 'pl-2' : ''}>
                                  <span className="f-bold">{appraisal.saw_appraised_value_formatted}</span>
                                  {appraisal.priceDiff && appraisal.saw_appraised_value > 700 ? ` (save ${appraisal.priceDiff.toFixed(2)} %)` : null}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      )
                    )}
                  </div> */}
                  <div className="compromises-list">Willing to compromise? You can search for these extensions .{getAvailableExtensions()}?</div>
                  {/* <div className="compromise-list row d-flex">
                    {availableExtensions.map((tld: string, index: number) => (
                      <div className="extension">
                        <button key={index} className="btn btn btn-grad-outline ml-auto bb-btn">{tld}</button>
                      </div>
                    ))}
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      <div className="ash-bg mt-5">
        <div className="container container-with-cards">
          <div className="main-text what-you-do">So… What Do You Do Now?</div>
          <label className="h2-title">Once You Know a Domain’s Value, Saw.com Can Help You:</label>
          <div className="row text-center ">
            <div className="col-lg-3 col-md-12 mt-2 card p-4  ">
              <div>
                <img className="card-images" src={buyPNG} alt="Infinity" />
              </div>
              <div className="h2-title underline">Buy</div>
              <p className="fs-12">Speak with us about domain brokerage and work with our experts to acquire your desired assets for the best price</p>
            </div>
            <div className="col-lg-3 col-md-12 mt-2 card p-4">
              <div>
                <img className="card-images" src={sellPNG} alt="Infinity" />
              </div>
              <div className="h2-title underline">Sell</div>
              <p>Tell us which domain you’d like to sell and let us create a comprehensive sales campaign that ensures maximum value.</p>
            </div>
            <div className="col-lg-3 col-md-12 mt-2 card p-4 ">
              <div>
                <img className="card-images" src={settingsPNG} alt="Infinity" />
              </div>
              <div className="h2-title underline">Upgrade</div>
              <p>Get an appraisal certificate and have the option to receive a written, detailed domain appraisal from our experts.</p>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="statistics mb-4">
          <div className="title">Saw.com Is One of The World’s Leading Domain Brokerage Firms...</div>
          <StatisticsDetails />
        </div>
        <div className="sub-title mt-5">
          <ContributedDomains addAnd={true} />
        </div>
        <Reviews />
        <div className="mt-4">
          <div className="why-saw-container container">
            <div className="title">That’s Why So Many Businesses Trust Saw.com To Facilitate & Execute Their Premium Domain Sales & Acquisitions</div>
            <WhyChooseSaw />
            <div className="row justify-content-center m-5">
              {/* {showBuyButton() ? ( */}
              <button className="btn btn-grad" onClick={() => buyDomain(userInterested.buy, appraisalDetails.domain)}>
                Buy a domain
              </button>
              {/* ) : null} */}
              {/* {showSellButton() ? ( */}
              <button
                className="btn btn-primary primary-dark text-uppercase d-flex align-items-center"
                onClick={() => {
                  history.push(`/sell`);
                  // history.push(`/sell-domain?domain=${appraisalDetails.domain}`);
                  // dispatch({ type: types.SET_CONTACT_US_DOMAIN, payload: appraisalDetails.domain });
                  // buyDomain(userInterested.sell, appraisalDetails.domain);
                  // scrollDoc(docIds.appraisalContactUs);
                }}
              >
                Sell a domain
              </button>
              {/* ) : null} */}
            </div>
          </div>
        </div>
      </div>
      {/* <div id="contact-us">
        <ContactUs />
      </div> */}
    </div>
  );
};

const mapStateToProps = () => ({});

export default connect(mapStateToProps, {})(AppraisalResult);
